export default __webpack_public_path__ + "static/media/ic_pause_48px.79d266c7.svg";